import api from "./api";

const ProjectCategoryService = {
  getAll: async (pageNumber = 1, noOfRows = 20) => {
  const response = await api.get(
    `/projectCategories/getAll?pageNumber=${pageNumber}&noOfRows=${noOfRows}`
  );
  return response.data.data || response.data;
},



  // Create new category
  create: async (data) => {
    const response = await api.post("/projectCategories/save", data);
    return response.data;
  },

  // Update category
  update: async (id, data) => {
    const response = await api.put(`/projectCategories/update/${id}`, data);
    return response.data;
  },

  // Delete (soft delete or toggle inactive)
  delete: async (id) => {
    const response = await api.put(`/projectCategories/updateStatus/${id}`);
    return response.data;
  },

  // Get only active categories
  getActive: async () => {
    const response = await api.get("/projectCategories/getActive/list");
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/projectCategories/getById/${id}`);
    return response.data.data || response.data;
  },
};

export default ProjectCategoryService;
